import React from 'react';
import PropTypes from 'prop-types';

import ActivityTypeInput from './activity_type_input';
import Errors from './errors';
import ManagedFormGroup from 'components/form/managed_input/form_group';
import Options from 'components/form/managed_input/options';
import TaggedBodyInput from 'bundles/apex/deals/tagged_body/input';

import { Form } from 'react-bootstrap-5';

// NOTE: The onChange function must be a setter from the useState hook in order to pass the current
//       state into the callback.  Otherwise you will get old values for other parts of the activity.
export default function ActivityForm({ activity, availableTags, errors, options, tagText, onChange }) {
  function handleChange(changes) {
    onChange(prevState => ({ ...prevState, ...changes }));
  }

  return (
    <Form className="d-flex flex-column gap-4">
      <Errors errors={errors} />

      <div className="d-flex flex-wrap justify-content-between align-items-center gap-2">
        <ActivityTypeInput
          activityType={activity.activityType}
          onChange={handleChange}
        />

        <ManagedFormGroup
          label="Date"
          name="date"
          popperPlacement="bottom-end"
          type="date"
          value={activity.date}
          onChange={handleChange}
        />
      </div>

      {options?.parents && options.parents.length > 1 &&
        <ManagedFormGroup
          includeBlank
          label="Listing"
          name="parentOptionValue"
          required
          type="select"
          value={activity.parentOptionValue}
          wrapperClassName="mt-0"
          onChange={handleChange}
        >
          <Options options={options.parents} />
        </ManagedFormGroup>
      }

      <Form.Group className="required d-flex flex-column">
        <Form.Label>
          Activity Details
        </Form.Label>
        <div className="text-muted">
          {tagText || 'Use "@" to tag a contact or user'}
        </div>

        { /* NOTE: The `key` prop is critical to keep Tagify from breaking on rerender */ }
        <TaggedBodyInput
          autoFocus
          availableTags={availableTags}
          availableTagsPath={activity.availableTagsPath}
          body={activity.body}
          bodyParts={activity.bodyParts}
          key={activity.id}
          onChange={body => handleChange({ body })}
        />
      </Form.Group>
    </Form>
  );
}

ActivityForm.propTypes = {
  activity: PropTypes.shape({
    activityType: PropTypes.string,
    body: PropTypes.string,
    bodyParts: PropTypes.array,
    date: PropTypes.string,
  }).isRequired,
  availableTags: PropTypes.array,
  errors: PropTypes.array,
  options: PropTypes.shape({
    parents: PropTypes.array,
  }),
  tagText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
